import * as React from 'react';
import { DataLayer, WebPage } from '@grandvisionhq/analytics';
import { TryInStoreProvider } from '@grandvisionhq/fun-try-in-store';
import { monetate } from '@grandvisionhq/svc-monetate';
import { mapMonetatePageType } from '../utils/map-monetate-page-type.js';
import { useBrPageContext } from '../context/context.js';
import { getPageSeo } from '../utils/get-page-seo.js';

const CmsAnalytics = ()=>{
    const page = useBrPageContext();
    const pageSeo = getPageSeo(page);
    React.useEffect(()=>{
        const pageName = page === null || page === void 0 ? void 0 : page.getComponent().getName().toLowerCase();
        const seoPageType = pageSeo === null || pageSeo === void 0 ? void 0 : pageSeo.type;
        DataLayer.pushPageTypeToDataLayer(seoPageType, pageName);
        if (seoPageType && !(pageName === null || pageName === void 0 ? void 0 : pageName.includes('checkout')) && !(pageName === null || pageName === void 0 ? void 0 : pageName.includes('product-detail-page'))) {
            const monetatePageName = mapMonetatePageType(seoPageType);
            // Some opcos don't have the pageseo correctly setup for homepage
            if (pageName === 'homepage') {
                monetate().commitMonetateEvent('main');
            } else if (// These pages contain other monetate API calls which need to be called simultaneously, so the pages will commit the event themselves
            monetatePageName !== 'category' && monetatePageName !== 'product' && monetatePageName !== 'cart') {
                monetate().commitMonetateEvent(monetatePageName);
            }
        }
    }, []);
    return pageSeo ? /*#__PURE__*/ React.createElement(WebPage, {
        pageType: pageSeo.type,
        url: pageSeo.canonicalUrl,
        name: pageSeo.title,
        description: pageSeo.description
    }) : null;
};
const CmsContainerPage = ({ children  })=>{
    return /*#__PURE__*/ React.createElement(TryInStoreProvider, null, children, /*#__PURE__*/ React.createElement(CmsAnalytics, null));
};
var CmsContainerPage$1 = CmsContainerPage;

export { CmsContainerPage, CmsContainerPage$1 as default };
//# sourceMappingURL=container.js.map
